import {TranslatableRental} from "./locations";
import {mainPhotoRoom, roomPhotos} from "./photo";

export const chambre2: TranslatableRental = {
  roomId: "605636",
  slugs: {
    fr: "chambre-double-numero-2",
    en: "standard-double-room-number-2"
  },
  name: {
    fr: "Chambre double",
    en: "Double room"
  },
  area: 22,
  capacity: 2,
  numberOfBeds: 1,
  numberOfBedrooms: 1,
  numberOfBathrooms: 1,
  description: {
    fr: "Cette chambre pour 2 personnes se compose d’un grand lit double ainsi que de sa salle de bain privée. La chambre est climatisée et à accès au Wifi. Vous pourrez également prendre le petit déjeuner dans le jardin si vous le souhaitez. La résidence où se trouve cette chambre dispose d'une piscine extérieure où vous pourrez vous détendre et profiter des beaux jours. Un jacuzzi sera à votre disposition, ainsi qu’un jardin très arboré dans lequel vous pourrez vous détendre et profiter du soleil. A 10 minutes à pied du centre de Saint Rémy vous trouverez un large choix de bars et de restaurants. Vous trouverez également plein de boutiques dans le cœur du village pour des souvenirs ou tout simplement pour vous promener.",
    en: "This room for 2 people features a large double bed and a private bathroom. It is air-conditioned and has Wi-Fi access. You can also enjoy breakfast in the garden if you wish. The residence offers an outdoor pool where you can relax and enjoy the sunshine. A jacuzzi is also available, along with a lush garden where you can unwind. Just a 10-minute walk from the center of Saint-Rémy, you'll find a wide selection of bars and restaurants, as well as many shops in the village center — perfect for souvenirs or a relaxing stroll.",
  },
  lodgifyId: "538972",
  equipments: [
    "ac",
    "tv",
    "wifi",
    "breakfast",
    "heater",
    "swimming",
    "toilet",
    "shower",
    "parking",
    "hair-dryer",
    "no-smoking",
    "household-linen"
  ],
  assets: roomPhotos,
  mainImage: mainPhotoRoom
};
